module.exports = __webpack_public_path__ + "static/media/child.3d37f607.svg";